module.exports = __webpack_public_path__ + "img/luckdraw.064b3ca6.png";